
import Vue from 'vue';
import liteYT from 'lite-youtube-embed';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import CTAbtn from './components/CTAbtn.vue';
import PrivacyPolicy from './components/PrivacyPolicy.vue';
import Logo from './components/TheLogo.vue';

Vue.config.productionTip = false;

Vue.component('cta-btn', CTAbtn);
Vue.component('privacy-policy', PrivacyPolicy);
Vue.component('mt-logo', Logo);

Vue.use(liteYT);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

// Build a new service worker:
// workbox generateSW workbox-config.js

// Check that service workers are supported
// if ('serviceWorker' in navigator) {
//   // Use the window load event to keep the page load performant
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/sw.js');
//   });
// }
